import { InsertEtiquetaCommandProps } from "api/Commands/InsertEtiquetaCommand"
import { FormikTouched } from "formik"
import { useEffect } from "react"
import { useHistory } from "react-router-dom"
import FormDocumentoCompletoStage from "./Components/FormDocumentoCompletoStage/FormDocumentoCompletoStage"
import ModalSelectContactDocumento from "./Components/ModalSelectContactDocument/ModalSelectContactDocument"
import SelectedArticlesDocument from "./Components/SelectedArticlesDocument/SelectedArticlesDocument"
import { EmpresaActivaDocProps } from "./FormCreacionDocumento"
import { DOCUMENT_SCREEN, handleOnHideCrearDocumento } from "./constant"

export interface FormikDocumentsProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: $TSMigrationFixMe
  setFieldValue: (
    field: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: $TSMigrationFixMe,
    shouldValidate?: boolean
  ) => Promise<void>
  handleSubmit?: () => void
  errors?: { [field: string]: string }
  empresaActiva?: EmpresaActivaDocProps
  isSubmitting?: boolean
  touched?: FormikTouched<InsertEtiquetaCommandProps>
  handleChange?: () => void
}

const CreacionDocumento = ({
  values,
  setFieldValue,
  errors,
  empresaActiva,
  handleSubmit,
  isSubmitting,
  touched,
  handleChange,
}: FormikDocumentsProps) => {
  const history = useHistory()
  useEffect(() => {
    if (empresaActiva?.id !== values.documentoType.empresaActiva) {
      history.push(handleOnHideCrearDocumento(values.documentoType.type))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresaActiva])

  return (
    <div>
      {values?.documentoType?.screen === DOCUMENT_SCREEN.SELECT_CONTACT && (
        <ModalSelectContactDocumento
          values={values}
          setFieldValue={setFieldValue}
        />
      )}
      {values?.documentoType?.screen === DOCUMENT_SCREEN.SELECT_ARTICULO && (
        <SelectedArticlesDocument
          values={values}
          setFieldValue={setFieldValue}
          empresaActiva={empresaActiva}
        />
      )}
      {values?.documentoType?.screen === DOCUMENT_SCREEN.FORM_COMPLETO && (
        <FormDocumentoCompletoStage
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          handleSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          touched={touched}
          handleChange={handleChange}
        />
      )}
    </div>
  )
}

export default CreacionDocumento
